export enum AppServicesType {
  EpStore = "EpStore",
  Oxy = "Oxy",
  EpExpress = "EpExpress",
  EpESG = "EpESG",
  EpCare = "EpCare",
  EpFlex = "EpFlex",
  Parameters = "Parameters",
}

export default AppServicesType;
